module.exports = __webpack_public_path__ + "img/lg_ring_r_s_0_null@3x.a33bc18b.png";